import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DelayedHoverService } from './delayed-hover.service';

// Source: https://blog.davidjs.com/2019/11/delayed-hover-event-in-angular/
@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[delayed-hover]',
    providers: [DelayedHoverService]
})
export class DelayedHoverDirective implements OnInit, OnDestroy {
    @Input() delay = 1500;

    @Output('delayed-hover') hoverEvent = new EventEmitter();

    constructor(private readonly element: ElementRef, private readonly delayedHoverService: DelayedHoverService) { }

    ngOnInit() {
        this.createMouseEnterDelay(
            this.element.nativeElement,
            show => {
                if (show) {
                    this.hoverEvent.emit(show);
                }
            },
            this.delay
        );
    }

    createMouseEnterDelay(element: HTMLElement, observer: (boolean) => void, hoverDelay = 300) {
        this.delayedHoverService.createMouseEnterDelay(element, observer, hoverDelay)
    }

    ngOnDestroy() {
    }
}
